import { memo, useCallback, useRef } from 'react';
import { Activity } from 'react';
import { MapRouter } from './map_router/mapRouter';
import { getActivityMode } from '../../../utils/getActivityMode';
import { useGoalStore, useDisplayStore } from '../../../store/sceneStore';

function NaviWidget() {
	const { data: display, setState: setDisplay } = useDisplayStore((s) => s);
	const goal = useGoalStore();
	const naviRef = useRef(null);

	const toggleRouter = useCallback(() => {
		setDisplay({ ...display, router: !display.router });
	}, [display]);

	const onClickRouterShow = useCallback(() => {
		toggleRouter();
	}, [toggleRouter]);

	const onClickRouterHide = useCallback(() => {
		toggleRouter();
	}, [toggleRouter]);

	if (goal.dst_mode !== 2) {
		return null;
	}

	return (
		<div>
			<Activity mode={getActivityMode(display.mode && !display.router)}>
				<button
					type='button'
					className='Button'
					style={{
						position: 'absolute',
						backgroundColor: 'rgba(0,0,0,0)',
						bottom: '0em',
						left: '0em',
						color: '#fff',
					}}
					onClick={onClickRouterShow}
					disabled={false}
				>
					<i className='mdi mdi-36px mdi-map'></i>
				</button>
			</Activity>
			<div
				className={`container_navi ${display.mode && display.router ? 'Show' : ''}`}
			>
				<Activity mode={getActivityMode(display.router)}>
					<MapRouter ref={naviRef} />
					<button
						type='button'
						className='Button'
						style={{
							position: 'absolute',
							color: 'rgba(39,39,48,1)',
							backgroundColor: 'rgba(0,0,0,0)',
							top: '0%',
							right: '0%',
							display: 'flex',
						}}
						onClick={onClickRouterHide}
						disabled={false}
					>
						<i className='mdi mdi-36px mdi-arrow-down-circle-outline'></i>
						<br></br>
					</button>
				</Activity>
			</div>
		</div>
	);
}

export default memo(NaviWidget);
